// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fs-6";
export var emphasizeQuantity = "_fs-3";
export var flatBottomCorners = "_fs-5";
export var productImage = "_fs-0";
export var quantityContainer = "_fs-2";
export var tooltip = "_fs-1";
export var wrapAndEllipsesOverflow = "_fs-4";